export default __webpack_public_path__ + "53f68830646fe3657602a7e057437f0b.png";